<template>
  <SideBar monitorType="system"></SideBar>
</template>
<script>
  import SideBar from './SideBar'
  export default {
    components: {SideBar}
  }
</script>